import { load } from "@cashfreepayments/cashfree-js";
import { useEffect, useState } from "react";
import { Container, Paper, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

function Checkout() {
  const [cashfree, setCashfree] = useState(null);
  const dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();
  const orderState = useSelector((state) => state?.orderState);
  console.log("order-confirm",orderState)
  const paymentSessionId = state?.paymentSessionId; // Extract payment session ID
  
  useEffect(() => {
    const initializeSDK = async () => {
      const instance = await load({ mode: "production" });
      // const instance = await load({ mode: "sandbox" });
      setCashfree(instance);
    };
    initializeSDK();
  }, []);

  // useEffect(() => {
  //   if (cashfree) {
  //     doPayment();
  //   }
  // }, [cashfree]);
  useEffect(() => {
    if (cashfree && paymentSessionId) {
      doPayment();
    }
  }, [cashfree, paymentSessionId]);

  const doPayment = async () => {
    if (!cashfree || !paymentSessionId) return;

    console.log("Session_ID",paymentSessionId,)
      let checkoutOptions = {
        paymentSessionId: paymentSessionId,
      // paymentSessionId:
      // "session_TM5hM4UwLnu1VDkTkohEitjTyw2faaAMbwCT1AHOywhHddYq2iijqYQ3GaUuCi-wjbPxQX7KS1HQ-2EZ3ATJmKRyaj20SxNTXgCQmHHztOCtBvyFG5sfEaAOQgpaymentpayment",
      //   //"session_9kpCMlYS4SpO-4H-Bz7RDlDlRIkL3rWdYK0gE9geyVG0UokdfmFIiQZz3MlEz5TJnARZ7xJ5udKHiRTaff1Q12Uvo72_V2PRfDLU1w-9Lak1Kd4xZTd-BJ4paymen",
        
      redirectTarget: "_self",
    };

    cashfree.checkout(checkoutOptions);
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 4, mt: 4, borderRadius: 2 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Redirecting to Payment checkout...
        </Typography>
      </Paper>
    </Container>
  );
}

export default Checkout;
